import { createContext, useContext } from 'react';
const GridContext = createContext({});
export const useGridContext = () => useContext(GridContext);
export default GridContext;
//# sourceMappingURL=GridContext.js.map